/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
    img: "https://i.ibb.co/yfzMF7Z/showcased-asset-desc.png",
    title: "Showcased Assets Description",
    description:
      "In this section you can view the assets that are showcased by you / your organisation",
    meta: [
      {
        key: "-",
        value: "Read More",
      },
      {
        key: "•",
        value: "Showcased Assets",
        path: "/showcased-assets",
      },
      // {
      //   key: "• Location",
      //   value: "",
      // },
      // {
      //   key:
      //     "The Brand protection also provides user scans done on the product batches which are not on the Shelf anymore.",
      //   value: "",
      // },
    ],
    // buttons: [
    //   {
    //     key: "edit",
    //     title: "Edit",
    //   },
    // ],
  };